import { Bold, Italic, Strikethrough, Heading2, Heading3, List, ListOrdered, Quote, Minus, Link2, Undo2, Redo2 } from "lucide-react";
import { keyHint } from "@/lib/platform";

const Btn = ({ on, onClick, label, icon: Icon, disabled, testid }) => (
  <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={onClick} disabled={disabled} aria-label={label} title={label} data-testid={testid}
    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded transition-colors disabled:opacity-30 ${on ? "bg-[#D97706]/20 text-[#F59E0B]" : "text-[#A8A090] hover:bg-[#1A202C] hover:text-[#F3EBDD]"}`}>
    <Icon className="h-4 w-4" />
  </button>
);

const Sep = () => <span className="mx-1 h-5 w-px shrink-0 bg-[#2D3442]" />;

export const RichToolbar = ({ editor, testid = "rich-toolbar", extra }) => {
  if (!editor) return null;
  const c = () => editor.chain().focus();
  const link = () => {
    const prev = editor.getAttributes("link").href || "";
    const url = window.prompt("Link address (leave empty to remove)", prev);
    if (url === null) return;
    if (!url.trim()) c().extendMarkRange("link").unsetLink().run();
    else c().extendMarkRange("link").setLink({ href: /^https?:\/\//.test(url) ? url : `https://${url}` }).run();
  };
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-0.5 border-b border-[#2D3442] px-2 py-1" data-testid={testid}>
      <Btn icon={Undo2} label={`Undo your changes (${keyHint("Z")})`} onClick={() => c().undo().run()} disabled={!editor.can().undo()} testid={`${testid}-undo`} />
      <Btn icon={Redo2} label={`Redo (${keyHint("Z", true)})`} onClick={() => c().redo().run()} disabled={!editor.can().redo()} testid={`${testid}-redo`} />
      <Sep />
      <Btn icon={Heading2} label="Heading" on={editor.isActive("heading", { level: 2 })} onClick={() => c().toggleHeading({ level: 2 }).run()} testid={`${testid}-h2`} />
      <Btn icon={Heading3} label="Subheading" on={editor.isActive("heading", { level: 3 })} onClick={() => c().toggleHeading({ level: 3 }).run()} testid={`${testid}-h3`} />
      <Btn icon={Bold} label={`Bold (${keyHint("B")})`} on={editor.isActive("bold")} onClick={() => c().toggleBold().run()} testid={`${testid}-bold`} />
      <Btn icon={Italic} label={`Italic (${keyHint("I")})`} on={editor.isActive("italic")} onClick={() => c().toggleItalic().run()} testid={`${testid}-italic`} />
      <Btn icon={Strikethrough} label={`Strikethrough (${keyHint("X", true)})`} on={editor.isActive("strike")} onClick={() => c().toggleStrike().run()} testid={`${testid}-strike`} />
      <Sep />
      <Btn icon={List} label={`Bullet list (${keyHint("8", true)})`} on={editor.isActive("bulletList")} onClick={() => c().toggleBulletList().run()} testid={`${testid}-bullets`} />
      <Btn icon={ListOrdered} label={`Numbered list (${keyHint("7", true)})`} on={editor.isActive("orderedList")} onClick={() => c().toggleOrderedList().run()} testid={`${testid}-numbers`} />
      <Btn icon={Quote} label={`Block quote (${keyHint("B", true)})`} on={editor.isActive("blockquote")} onClick={() => c().toggleBlockquote().run()} testid={`${testid}-quote`} />
      <Btn icon={Minus} label="Divider" onClick={() => c().setHorizontalRule().run()} testid={`${testid}-hr`} />
      <Btn icon={Link2} label="Link" on={editor.isActive("link")} onClick={link} testid={`${testid}-link`} />
      {extra && <><span className="flex-1" />{extra}</>}
    </div>
  );
};
